import React from "react";
import { IconProps } from "@phosphor-icons/react";

export const Edit: React.FC<IconProps> = (iconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...iconProps}>
    <path d="M8 13.3333H14" stroke="#4D4D4D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M11 2.33334C11.2652 2.06813 11.6249 1.91913 12 1.91913C12.1857 1.91913 12.3696 1.95571 12.5412 2.02678C12.7128 2.09785 12.8687 2.20202 13 2.33334C13.1313 2.46466 13.2355 2.62057 13.3066 2.79215C13.3776 2.96373 13.4142 3.14762 13.4142 3.33334C13.4142 3.51906 13.3776 3.70296 13.3066 3.87454C13.2355 4.04612 13.1313 4.20202 13 4.33334L4.66667 12.6667L2 13.3333L2.66667 10.6667L11 2.33334Z"
      stroke="#4D4D4D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShoppingCart: React.FC<IconProps> = (iconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...iconProps}>
    <g clipPath="url(#clip0_33403_1211)">
      <path
        d="M6 14.6667C6.36819 14.6667 6.66667 14.3682 6.66667 14C6.66667 13.6318 6.36819 13.3333 6 13.3333C5.63181 13.3333 5.33333 13.6318 5.33333 14C5.33333 14.3682 5.63181 14.6667 6 14.6667Z"
        stroke="#4D4D4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 14.6667C13.7015 14.6667 14 14.3682 14 14C14 13.6318 13.7015 13.3333 13.3333 13.3333C12.9651 13.3333 12.6667 13.6318 12.6667 14C12.6667 14.3682 12.9651 14.6667 13.3333 14.6667Z"
        stroke="#4D4D4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.666668 0.666664H3.33333L5.12 9.59333C5.18096 9.90026 5.34794 10.176 5.5917 10.3722C5.83546 10.5684 6.14047 10.6727 6.45333 10.6667H12.9333C13.2462 10.6727 13.5512 10.5684 13.795 10.3722C14.0387 10.176 14.2057 9.90026 14.2667 9.59333L15.3333 4H4"
        stroke="#4D4D4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_33403_1211">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Trash: React.FC<IconProps> = (iconProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 4H3.33333H14"
      stroke="#4D4D4D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 4V13.3333C12.6667 13.687 12.5262 14.0261 12.2761 14.2761C12.0261 14.5262 11.687 14.6667 11.3333 14.6667H4.66667C4.31304 14.6667 3.9739 14.5262 3.72386 14.2761C3.47381 14.0261 3.33333 13.687 3.33333 13.3333V4M5.33333 4V2.66667C5.33333 2.31305 5.47381 1.97391 5.72386 1.72386C5.97391 1.47381 6.31304 1.33334 6.66667 1.33334H9.33333C9.68695 1.33334 10.0261 1.47381 10.2761 1.72386C10.5262 1.97391 10.6667 2.31305 10.6667 2.66667V4"
      stroke="#4D4D4D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66667 7.33334V11.3333"
      stroke="#4D4D4D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33333 7.33334V11.3333"
      stroke="#4D4D4D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MapIcon: React.FC<IconProps> = (iconProps) => (
  <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1711_33094)">
  <rect width="88" height="88" rx="44" fill="#C5F0FB"/>
  <path d="M92.9111 61.1934L1.70014 32.6963H-4.22724L-7.41895 90.1462L39.544 96.0735L92.9111 83.7629V61.1934Z" fill="url(#paint0_linear_1711_33094)" stroke="white" stroke-width="6"/>
  <path d="M68.749 52.4775L45.1133 89.3777" stroke="white" stroke-width="6"/>
  <path d="M44 18C54.2102 18 62.4873 26.2771 62.4873 36.4873V38.7207C62.4872 42.5066 61.2892 46.1956 59.0645 49.2588L47.0283 65.8301C45.5337 67.8879 42.4663 67.8879 40.9717 65.8301L28.9355 49.2588C26.7108 46.1956 25.5128 42.5066 25.5127 38.7207V36.4873C25.5127 26.2771 33.7898 18 44 18ZM44 26.668C40.1713 26.668 37.0676 29.7719 37.0674 33.6006C37.0674 37.4294 40.1712 40.5332 44 40.5332C47.8288 40.5332 50.9326 37.4294 50.9326 33.6006C50.9324 29.7719 47.8287 26.668 44 26.668Z" fill="url(#paint1_linear_1711_33094)"/>
  <path d="M44 18C54.2102 18 62.4873 26.2771 62.4873 36.4873V38.7207C62.4872 42.5066 61.2892 46.1956 59.0645 49.2588L47.0283 65.8301C45.5337 67.8879 42.4663 67.8879 40.9717 65.8301L28.9355 49.2588C26.7108 46.1956 25.5128 42.5066 25.5127 38.7207V36.4873C25.5127 26.2771 33.7898 18 44 18ZM44 26.668C40.1713 26.668 37.0676 29.7719 37.0674 33.6006C37.0674 37.4294 40.1712 40.5332 44 40.5332C47.8288 40.5332 50.9326 37.4294 50.9326 33.6006C50.9324 29.7719 47.8287 26.668 44 26.668Z" fill="url(#paint2_linear_1711_33094)" fill-opacity="0.5"/>
  <path d="M44 18C54.2102 18 62.4873 26.2771 62.4873 36.4873V38.7207C62.4872 42.5066 61.2892 46.1956 59.0645 49.2588L47.0283 65.8301C45.5337 67.8879 42.4663 67.8879 40.9717 65.8301L28.9355 49.2588C26.7108 46.1956 25.5128 42.5066 25.5127 38.7207V36.4873C25.5127 26.2771 33.7898 18 44 18ZM44 26.668C40.1713 26.668 37.0676 29.7719 37.0674 33.6006C37.0674 37.4294 40.1712 40.5332 44 40.5332C47.8288 40.5332 50.9326 37.4294 50.9326 33.6006C50.9324 29.7719 47.8287 26.668 44 26.668Z" fill="url(#paint3_linear_1711_33094)" fill-opacity="0.1"/>
  </g>
  <rect x="1" y="1" width="86" height="86" rx="43" stroke="black" stroke-opacity="0.1" stroke-width="2"/>
  <defs>
  <linearGradient id="paint0_linear_1711_33094" x1="42.7461" y1="32.6963" x2="42.7461" y2="96.0735" gradientUnits="userSpaceOnUse">
  <stop stop-color="#DAFFCF"/>
  <stop offset="1" stop-color="#A1CF51"/>
  </linearGradient>
  <linearGradient id="paint3_linear_1711_33094" x1="44" y1="18" x2="54.5332" y2="18" gradientUnits="userSpaceOnUse">
  <stop stop-color="white" stop-opacity="0"/>
  <stop stop-color="white"/>
  <stop offset="1" stop-color="white"/>
  </linearGradient>
  <clipPath id="clip0_1711_33094">
  <rect width="88" height="88" rx="44" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  
);

export const PinIcon: React.FC<IconProps> = (iconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37"
    height="50"
    viewBox="0 0 37 50"
    fill="none"
    {...iconProps}>
    <path
      d="M18.4873 0C28.6975 1.13389e-05 36.9746 8.27707 36.9746 18.4873V20.7207C36.9746 24.5066 35.7765 28.1956 33.5518 31.2588L21.5156 47.8301C20.021 49.8879 16.9536 49.8879 15.459 47.8301L3.42285 31.2588C1.19807 28.1956 5.87996e-05 24.5066 0 20.7207V18.4873C0 8.27706 8.27706 0 18.4873 0ZM18.4873 8.66797C14.6586 8.66797 11.5549 11.7719 11.5547 15.6006C11.5547 19.4294 14.6585 22.5332 18.4873 22.5332C22.3161 22.5332 25.4199 19.4294 25.4199 15.6006C25.4198 11.7719 22.316 8.66797 18.4873 8.66797Z"
      fill="url(#paint0_linear_1711_33097)"
    />
    <path
      d="M18.4873 0C28.6975 1.13389e-05 36.9746 8.27707 36.9746 18.4873V20.7207C36.9746 24.5066 35.7765 28.1956 33.5518 31.2588L21.5156 47.8301C20.021 49.8879 16.9536 49.8879 15.459 47.8301L3.42285 31.2588C1.19807 28.1956 5.87996e-05 24.5066 0 20.7207V18.4873C0 8.27706 8.27706 0 18.4873 0ZM18.4873 8.66797C14.6586 8.66797 11.5549 11.7719 11.5547 15.6006C11.5547 19.4294 14.6585 22.5332 18.4873 22.5332C22.3161 22.5332 25.4199 19.4294 25.4199 15.6006C25.4198 11.7719 22.316 8.66797 18.4873 8.66797Z"
      fill="url(#paint1_linear_1711_33097)"
      fillOpacity="0.5"
    />
    <path
      d="M18.4873 0C28.6975 1.13389e-05 36.9746 8.27707 36.9746 18.4873V20.7207C36.9746 24.5066 35.7765 28.1956 33.5518 31.2588L21.5156 47.8301C20.021 49.8879 16.9536 49.8879 15.459 47.8301L3.42285 31.2588C1.19807 28.1956 5.87996e-05 24.5066 0 20.7207V18.4873C0 8.27706 8.27706 0 18.4873 0ZM18.4873 8.66797C14.6586 8.66797 11.5549 11.7719 11.5547 15.6006C11.5547 19.4294 14.6585 22.5332 18.4873 22.5332C22.3161 22.5332 25.4199 19.4294 25.4199 15.6006C25.4198 11.7719 22.316 8.66797 18.4873 8.66797Z"
      fill="url(#paint2_linear_1711_33097)"
      fillOpacity="0.1"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1711_33097"
        x1="18.4873"
        y1="0"
        x2="18.4873"
        y2="21.6051"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#888888" />
        <stop offset="1" stopColor="#222222" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1711_33097"
        x1="-0.566431"
        y1="1.04585"
        x2="9.52859"
        y2="20.4133"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#0099C0" />
        <stop offset="1" stopColor="#0099C0" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1711_33097"
        x1="18.4873"
        y1="0"
        x2="29.0205"
        y2="0"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0" />
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export const FadedMap = () =>
<svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1711_33478)">
<rect width="88" height="88" rx="44" fill="#E7E7E7"/>
<path d="M44 18C54.2102 18 62.4873 26.2771 62.4873 36.4873V38.7207C62.4872 42.5066 61.2892 46.1956 59.0645 49.2588L47.0283 65.8301C45.5337 67.8879 42.4663 67.8879 40.9717 65.8301L28.9355 49.2588C26.7108 46.1956 25.5128 42.5066 25.5127 38.7207V36.4873C25.5127 26.2771 33.7898 18 44 18ZM44 26.668C40.1713 26.668 37.0676 29.7719 37.0674 33.6006C37.0674 37.4294 40.1712 40.5332 44 40.5332C47.8288 40.5332 50.9326 37.4294 50.9326 33.6006C50.9324 29.7719 47.8287 26.668 44 26.668Z" fill="url(#paint0_linear_1711_33478)"/>
<path d="M44 18C54.2102 18 62.4873 26.2771 62.4873 36.4873V38.7207C62.4872 42.5066 61.2892 46.1956 59.0645 49.2588L47.0283 65.8301C45.5337 67.8879 42.4663 67.8879 40.9717 65.8301L28.9355 49.2588C26.7108 46.1956 25.5128 42.5066 25.5127 38.7207V36.4873C25.5127 26.2771 33.7898 18 44 18ZM44 26.668C40.1713 26.668 37.0676 29.7719 37.0674 33.6006C37.0674 37.4294 40.1712 40.5332 44 40.5332C47.8288 40.5332 50.9326 37.4294 50.9326 33.6006C50.9324 29.7719 47.8287 26.668 44 26.668Z" fill="url(#paint1_linear_1711_33478)" fill-opacity="0.5"/>
<path d="M44 18C54.2102 18 62.4873 26.2771 62.4873 36.4873V38.7207C62.4872 42.5066 61.2892 46.1956 59.0645 49.2588L47.0283 65.8301C45.5337 67.8879 42.4663 67.8879 40.9717 65.8301L28.9355 49.2588C26.7108 46.1956 25.5128 42.5066 25.5127 38.7207V36.4873C25.5127 26.2771 33.7898 18 44 18ZM44 26.668C40.1713 26.668 37.0676 29.7719 37.0674 33.6006C37.0674 37.4294 40.1712 40.5332 44 40.5332C47.8288 40.5332 50.9326 37.4294 50.9326 33.6006C50.9324 29.7719 47.8287 26.668 44 26.668Z" fill="url(#paint2_linear_1711_33478)" fill-opacity="0.1"/>
</g>
<rect x="1" y="1" width="86" height="86" rx="43" stroke="black" stroke-opacity="0.05" stroke-width="2"/>
<defs>
<linearGradient id="paint2_linear_1711_33478" x1="44" y1="18" x2="54.5332" y2="18" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0"/>
<stop stop-color="white"/>
<stop offset="1" stop-color="white"/>
</linearGradient>
<clipPath id="clip0_1711_33478">
<rect width="88" height="88" rx="44" fill="white"/>
</clipPath>
</defs>
</svg>
